export default "__VITE_ASSET__DHj2b8Rt__"